import component from "containers/StaticPages/verifyEmailRequired";

export default {
  key: "verify-email-required",
  title: "Verify Email Required",
  path: "/verify-email-required",
  linkTarget: "/verify-email-required",
  component,
};
